import { render, staticRenderFns } from "./LeavesReports.vue?vue&type=template&id=eb9a2a82"
import script from "./LeavesReports.vue?vue&type=script&lang=js"
export * from "./LeavesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports